import addQuarters from'../addQuarters/index.js';import startOfQuarter from'../startOfQuarter/index.js';import toDate from'../toDate/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * var result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */export default function eachQuarterOfInterval(dirtyInterval){requiredArgs(1,arguments);var interval=dirtyInterval||{};var startDate=toDate(interval.start);var endDate=toDate(interval.end);var endTime=endDate.getTime();// Throw an exception if start date is after end date or if any date is `Invalid Date`
if(!(startDate.getTime()<=endTime)){throw new RangeError('Invalid interval');}var startDateQuarter=startOfQuarter(startDate);var endDateQuarter=startOfQuarter(endDate);endTime=endDateQuarter.getTime();var quarters=[];var currentQuarter=startDateQuarter;while(currentQuarter.getTime()<=endTime){quarters.push(toDate(currentQuarter));currentQuarter=addQuarters(currentQuarter,1);}return quarters;}